export default __webpack_public_path__ + "static/media/gallery2.53015a62.jpeg";